export default function DeliveryEssentials({ delivery, deliveryFailed = false }) {
  if (!delivery) return null;
  const collection = delivery.collection;
  return <div className="mt-3 space-y-2 text-sm">
    <p className="font-semibold">{delivery.recipientName || 'Recipient name unavailable - contact your store'}</p>
    {delivery.address && <p>{delivery.address}</p>}
    {delivery.instructions && <p>Delivery instructions: {delivery.instructions}</p>}
    {delivery.recipientPhone && <a className="inline-flex min-h-11 items-center font-semibold text-emerald-700 underline dark:text-emerald-300" href={`tel:${delivery.recipientPhone.replace(/[^+0-9]/g,'')}`}>Call recipient</a>}
    <p className="rounded-xl bg-stone-100 p-3 font-semibold dark:bg-white/10">{collection?.status === 'COLLECT'
      ? `Collect ${new Intl.NumberFormat('en-PH',{style:'currency',currency:'PHP'}).format(collection.amountCents/100)}`
      // Cash taken for a delivery that then failed is not a payment: it goes
      // back to the customer or to the store (APP-DEL-027).
      : collection?.status === 'PAID' ? (deliveryFailed ? 'Cash collected, but this delivery did not go through - it goes back to the customer or to the store' : 'Paid - do not collect') : 'Payment needs review - contact your store before collecting'}</p>
  </div>;
}
